angular.module('unica_grand_prix.grand_prix_controllers', [])

.controller('GrandPrixBasicController',
	function(
		$rootScope, $scope, $state, $stateParams, $window,
		$confirm,
		GrandPrixRankingListService, GrandPrixRankingEditService
	) {


	$rootScope.getRankingByID = function( rankingId )
	{
		$scope.showLoader();

		GrandPrixRankingListService
			.get( rankingId )
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.rankingData = data;

				$rootScope.getEvent( $rootScope.rankingData.event_id );

				$scope.$broadcast('ranking_loaded');
			});
	};

});